import { FormEvent, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { api } from "../../api/client";
import { AlertBanner } from "../../components/feedback/AlertBanner";
import { AuthLayout } from "../../components/layout/AuthLayout";
import { apiError } from "../../lib/apiError";

export function AccountDeletionCancelPage() {
  const [params] = useSearchParams();
  const token = params.get("token")?.trim() || "";
  const [error, setError] = useState<string | null>(
    token ? null : "Brak tokenu anulowania. Użyj linku z wiadomości e-mail.",
  );
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token || busy || done) {
      return;
    }
    void cancelDeletion();
  }, [token]);

  async function cancelDeletion() {
    if (!token) {
      return;
    }
    setBusy(true);
    setError(null);
    const result = await api.POST("/api/account/deletion-cancel", {
      body: { token },
    });
    setBusy(false);
    if (result.error) {
      setError(apiError(result.error, "Nie udało się anulować usunięcia konta."));
      return;
    }
    setDone(true);
  }

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    await cancelDeletion();
  }

  return (
    <AuthLayout
      title="Anulowanie usunięcia konta"
      subtitle="Przywrócenie dostępu do konta AgroHodowca"
    >
      <AlertBanner variant="error" message={error} onDismiss={() => setError(null)} />
      {done ? (
        <div className="auth__success">
          <p>Usunięcie konta zostało anulowane. Możesz się ponownie zalogować.</p>
          <Link className="btn" to="/login">
            Przejdź do logowania
          </Link>
        </div>
      ) : busy ? (
        <p className="muted">Anulowanie usunięcia konta…</p>
      ) : token ? (
        <form className="auth__form" onSubmit={(event) => void onSubmit(event)}>
          <p className="muted">
            Kliknij poniżej, aby anulować zaplanowane usunięcie konta.
          </p>
          <button className="btn" type="submit" disabled={busy}>
            Anuluj usunięcie konta
          </button>
        </form>
      ) : (
        <p className="muted">
          <Link to="/login">Wróć do logowania</Link>
        </p>
      )}
    </AuthLayout>
  );
}
